import { BALANCE } from '../config/balance';

/**
 * 每日变体：全部为纯数值调制，不引入任何新机制。
 * 变体归属「对局日期」（UTC），练习影子日使用 T-1 的变体。
 */
export interface Variant {
  id: string;
  label: string;
  desc: string;
  playerSpeedMul: number;
  playerMaxHpMul: number;
  xpMul: number;
  spawnCountMul: number;
  enemyHpMul: number;
  eliteBossHpMul: number;
  goldMul: number;
  dropChanceMul: number;
  eliteGemMul: number;
  eliteGoldMul: number;
  rerollCost: number;
}

const BASE: Omit<Variant, 'id' | 'label' | 'desc'> = {
  playerSpeedMul: 1,
  playerMaxHpMul: 1,
  xpMul: 1,
  spawnCountMul: 1,
  enemyHpMul: 1,
  eliteBossHpMul: 1,
  goldMul: 1,
  dropChanceMul: 1,
  eliteGemMul: 1,
  eliteGoldMul: 1,
  rerollCost: BALANCE.gold.rerollCost,
};

function v(id: string, label: string, desc: string, patch: Partial<Variant>): Variant {
  return { ...BASE, id, label, desc, ...patch };
}

/** UTC 星期 → 变体（0=周日 … 6=周六）。 */
const BY_WEEKDAY: Record<number, Variant> = {
  1: v('dash', '周一疾跑', '玩家移速 +40%', {
    playerSpeedMul: 1.4,
  }),
  2: v('hunger', '周二饥饿', '经验获取 ×0.75', {
    xpMul: 0.75,
  }),
  3: v('carnival', '周三狂欢', '怪物数量 ×2、怪物血量 ×0.6', {
    spawnCountMul: 2,
    enemyHpMul: 0.6,
  }),
  4: v('fragile', '周四脆皮', '玩家血量 ×0.6', {
    playerMaxHpMul: 0.6,
  }),
  5: v('greed_day', '周五贪婪', '金币 ×2、reroll 降价', {
    goldMul: 2,
    dropChanceMul: 1.4,
    rerollCost: 12,
  }),
  6: v('elite_day', '周六精英', '精英与 Boss 血量 ×1.5、掉落升级', {
    eliteBossHpMul: 1.5,
    dropChanceMul: 1.3,
    eliteGemMul: 1.5,
    eliteGoldMul: 1.5,
  }),
  0: v('pure', '周日纯净', '无变体 · 周冠军结算日', {}),
};

/** 按对局日期（YYYY-MM-DD，UTC）取变体。 */
export function variantForDate(date: string): Variant {
  const day = new Date(`${date}T00:00:00Z`).getUTCDay();
  return BY_WEEKDAY[day] ?? BY_WEEKDAY[0];
}
